import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)' };
const WDAYS = ['ஞா','தி','செ','பு','வி','வெ','ச'];
const getIcon = (sp) => { if(!sp) return ''; if(sp.includes('அமாவாசை')) return '🌑'; if(sp.includes('பௌர்ணமி')) return '🌕'; if(sp.includes('ஏகாதசி')) return '🙏'; if(sp.includes('சதுர்த்தி')) return '🐘'; if(sp.includes('ஷஷ்டி')) return '🔱'; if(sp.includes('கிருத்திகை')) return '🔥'; if(sp.includes('ப்ரதோஷ')) return '🕉️'; return '⭐'; };

const PremiumCalendarPage = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth());
  const [allData, setAllData] = useState([]);
  const [sel, setSel] = useState(null);
  const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  useEffect(() => { axios.get('/data/panchangam_data-2025-to-2028.json').then(r=>setAllData(r.data)).catch(()=>{}); }, []);

  const dayMap = useMemo(() => {
    const m = {};
    allData.forEach(d => { const p = d.EnglishDate.split('/'); m[`${p[2]}-${String(parseInt(p[0])).padStart(2,'0')}-${String(parseInt(p[1])).padStart(2,'0')}`] = d; });
    return m;
  }, [allData]);

  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const weeks = []; let week = new Array(firstDay).fill(null);
  for (let d = 1; d <= daysInMonth; d++) { week.push(d); if (week.length===7) { weeks.push(week); week=[]; } }
  if (week.length>0) { while(week.length<7) week.push(null); weeks.push(week); }
  const getKey = (d) => `${year}-${String(month+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
  const isToday = (d) => { const t=new Date(); return d===t.getDate()&&month===t.getMonth()&&year===t.getFullYear(); };
  const selData = sel ? dayMap[getKey(sel)] : null;
  const fmt = v => v!=null ? Number(v).toFixed(2) : '';

  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <h1 style={{color:'#fff',margin:0,fontSize:'1rem',fontWeight:900}}>👑 Premium Calendar</h1>
        <div style={{color:'#c8e6c9',fontSize:'0.7rem'}}>Complete Panchangam Calendar</div>
      </div>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'8px',background:'#fff',borderRadius:'10px',padding:'8px 12px',border:'1px solid '+T.border}}>
        <button onClick={()=>{if(month===0){setMonth(11);setYear(year-1);}else setMonth(month-1);setSel(null);}} style={{border:'none',background:T.greenDk,color:'#fff',borderRadius:'50%',width:'30px',height:'30px',cursor:'pointer'}}>◀</button>
        <div style={{fontWeight:900,fontSize:'1rem',color:T.greenDk}}>{MONTHS[month]} {year}</div>
        <button onClick={()=>{if(month===11){setMonth(0);setYear(year+1);}else setMonth(month+1);setSel(null);}} style={{border:'none',background:T.greenDk,color:'#fff',borderRadius:'50%',width:'30px',height:'30px',cursor:'pointer'}}>▶</button>
      </div>
      <div style={{background:'#fff',borderRadius:'10px',overflow:'hidden',border:'2px solid '+T.greenDk,marginBottom:'10px'}}>
        <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',background:T.greenDk}}>
          {WDAYS.map((w,i)=><div key={i} style={{textAlign:'center',padding:'5px',color:i===0?'#ffcdd2':'#fff',fontSize:'0.7rem',fontWeight:700}}>{w}</div>)}
        </div>
        {weeks.map((wk,wi)=>(
          <div key={wi} style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)'}}>
            {wk.map((d,di)=>{
              if(!d) return <div key={di} style={{minHeight:'60px',background:'#fafafa',border:'1px solid #f0f0f0'}}/>;
              const pd=dayMap[getKey(d)]; const sp=pd?.DaySpecialityInTamil; const icon=getIcon(sp);
              return (
                <div key={di} onClick={()=>setSel(sel===d?null:d)} style={{
                  minHeight:'60px',padding:'2px',cursor:'pointer',border:'1px solid #eee',
                  background:sel===d?'#e8f5e9':isToday(d)?'#fff8e1':'#fff'
                }}>
                  <div style={{fontSize:'0.8rem',fontWeight:isToday(d)?900:600,color:di===0?'#c62828':T.greenDk,textAlign:'right',paddingRight:'3px'}}>{d}</div>
                  {pd&&<div style={{fontSize:'0.4rem',color:T.maroon,textAlign:'center'}}>{pd.TamilDate}</div>}
                  {pd&&<div style={{fontSize:'0.35rem',color:'#555',textAlign:'center'}}>{pd.ThithiNameInTamil?.substring(0,5)}</div>}
                  {pd&&<div style={{fontSize:'0.35rem',color:'#777',textAlign:'center'}}>{pd.NakshatraNameInTamil?.substring(0,4)}</div>}
                  {icon&&<div style={{textAlign:'center',fontSize:'0.6rem'}}>{icon}</div>}
                </div>
              );
            })}
          </div>
        ))}
      </div>
      {selData && (
        <div style={{background:T.cream,borderRadius:'10px',padding:'12px',border:'2px solid '+T.greenDk}}>
          <div style={{fontWeight:900,fontSize:'1rem',color:T.greenDk,textAlign:'center',marginBottom:'8px'}}>
            {sel}-{String(month+1).padStart(2,'0')}-{year} — {selData.DayNameInTamil}
          </div>
          <div style={{fontSize:'0.75rem',textAlign:'center',color:T.maroon,marginBottom:'10px'}}>{selData.YearNameInTamil} • {selData.TamilMonth}-{selData.TamilDate}</div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'4px',fontSize:'0.7rem'}}>
            {[['🌙 திதி',`${selData.ThithiNameInTamil} (${fmt(selData.ThithiDuration)})`],['⭐ நக்ஷத்ரம்',`${selData.NakshatraNameInTamil} (${fmt(selData.NakshatraDuration)})`],
              ['🔄 யோகம்',selData.YogaNameInTamil],['📐 கரணம்',selData.KaranamNameInTamil],
              ['☀️ உதயம்',fmt(selData.SuryaUdhayam)],['🌅 அஸ்தமனம்',fmt(selData.SuryaAsthamanam)],
              ['🔮 பக்ஷம்',selData.PakshamNameInTamil],['📿 ராசி',selData.RaasiNameInTamil||'—']
            ].map(([l,v])=>(
              <div key={l} style={{background:'#fff',padding:'5px',borderRadius:'6px',border:'1px solid #eee'}}>
                <div style={{fontSize:'0.55rem',color:'#888'}}>{l}</div><div style={{fontWeight:700,color:T.greenDk}}>{v}</div>
              </div>
            ))}
          </div>
          {selData.DaySpecialityInTamil&&<div style={{marginTop:'6px',background:'#fff3e0',padding:'6px',borderRadius:'6px',textAlign:'center',fontSize:'0.8rem',fontWeight:700,color:T.orange}}>⭐ {selData.DaySpecialityInTamil}</div>}
          {selData.ShraadhdhaThithiNameInTamil&&<div style={{marginTop:'4px',background:'#f3e5f5',padding:'4px',borderRadius:'6px',textAlign:'center',fontSize:'0.7rem',color:'#6a1b9a'}}>🙏 ச்ராத்தம்: {selData.ShraadhdhaThithiNameInTamil}</div>}
        </div>
      )}
    </div>
  );
};
export default PremiumCalendarPage;